import {
  LitElement,
  SVGTemplateResult,
  TemplateResult,
  html,
  svg,
} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import innerCSS from './se-logo.inner.pcss?inline';
import logoBgLight from '../../../public/vectors/logo/logoBgLight';
import logoBgDark from '../../../public/vectors/logo/logoBgDark';

export const seLogoVariants = ['light', 'dark'] as const;

export type SeLogoVariant = typeof seLogoVariants[number];

/**
 * The SeLogo component
 * @element se-logo
 */
@customElement('se-logo')
export class SeLogo extends LitElement {
  private stylesheetController = new AdoptedStyleSheets(this, {
    encapsulatedCSS: innerCSS,
  });

  /**
   * sets the logo to light or dark background version.
   */
  @property({ type: String })
  variant: SeLogoVariant;

  /**
   * if true logo will not be wrapped in an <a> linking back to the homepage.
   */
  @property({ type: Boolean })
  isDecorative: boolean;

  logoAlt(): SVGTemplateResult {
    return svg`${unsafeSVG(logoBgLight)}`;
  }

  logo(): SVGTemplateResult {
    return svg`${unsafeSVG(logoBgDark)}`;
  }

  logoTemplate() {
    if (this.variant === 'light') {
      return html`<div class="se-logo">${this.logoAlt()}</div>`;
    } else {
      return html`<div class="se-logo">${this.logo()}</div>`;
    }
  }

  render(): TemplateResult {
    return html`
      ${!this.isDecorative
        ? html` <a aria-label="Homepage" href="/"> ${this.logoTemplate()} </a> `
        : html`${this.logoTemplate()}`}
    `;
  }
}
